import { useData } from "@hooks/useData";
import http from "@core/fetch";
import { components } from "@apiSchema";
import { iPermissionFields, PermissionSection } from "@models/PermissionSection";

type Response = components['schemas']['TopTrendKeywordsModelIListChainPermissionWrapper'];
export type TopGrowingCategory = NonNullable<Response['data']>[number];
export type Data = iPermissionFields & {
    data: NonNullable<Response['data']>;
};

const DEFAULT_DATA: Data = {
    permissionLevel: PermissionSection.getPermissionLevel(),
    hasData: true,
    data: [],
}

async function getTopGrowingKeywords(): Promise<Data> {
    const response: Response = await http.get('get home top growing keywords');

    try {
        return {
            permissionLevel: PermissionSection.getPermissionLevel(response.permissionLevel),
            hasData: response.hasData ?? true,
            data: response.data ?? [],
        };
    } catch {
        return DEFAULT_DATA;
    }
}

export function useHomeGetTopGrowingKeywords() {
    return useData(DEFAULT_DATA, getTopGrowingKeywords);
}